// extracted by mini-css-extract-plugin
export default {"distributor-report-container":"distributor_distributor-report-container__a1nSU"};